
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 44 44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"22","cy":"22","r":"22","fill":"#3617CE"}}),_c('path',{attrs:{"d":"M30.333 13H13.666v4.238h16.667V13zM19.604 18.567v12.334h4.791v-9.906l-4.791-2.428z","fill":"#fff"}})])
      }
    
      }
    